// https://stackoverflow.com/questions/42463263/wrapping-a-react-router-link-in-an-html-button
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'antd';

const LinkButton = (props) => {
  // noinspection JSUnusedLocalSymbols
  const {
    history,
    location,
    match,
    staticContext,
    to,
    onClick,
    ...rest
  } = props;
  return (
    <Button
      {...rest}
      onClick={(event) => {
        onClick && onClick(event);
        if (typeof to === 'function') {
          history.push(to(match));
        } else {
          history.push(to);
        }
      }}
    />
  );
};

export default withRouter(LinkButton);



// WEBPACK FOOTER //
// ./src/components/Boilerplate/LinkButton.js